import { ComponentProps } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { ITextProps } from 'native-base';

import { ISimpleHomePageFragment } from 'generated/sanity-graphql';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { CustomEventNames } from 'state/amplitude';
import { useServiceModeContext } from 'state/service-mode';

export interface ISimpleHomePageItemProps {
  item: ISimpleHomePageFragment;
  flatListDimensions: { height: number; width: number } | null;
}

export interface ISimpleHomePageProps extends ISimpleHomePageItemProps {
  numberOfItemsInCart: number;
  serviceMode: ReturnType<typeof useServiceModeContext>['serviceMode'];
  navigate: ReturnType<typeof useNavigation>['navigate'];
}

export interface ICTAButtonProps {
  primary?: boolean;
  children: string;
  defaultLinkTo: string;
  isMatchingServiceMode: boolean;
  iconVariant: ComponentProps<typeof Icon>['variant'];
  numberOfItemsInCart: number;
  navigate: ReturnType<typeof useNavigation>['navigate'];
  marginTop?: string;
  eventName: CustomEventNames;
  itemId: string;
  backgroundColor?: string;
  _text?: ITextProps;
  validatePreCurbsideOrder: () => boolean;
}

export interface ICTAButtonsProps {
  navigate: ReturnType<typeof useNavigation>['navigate'];
  numberOfItemsInCart: number;
  serviceMode: ReturnType<typeof useServiceModeContext>['serviceMode'];
  itemId: string;
}
